import React, { ReactNode } from 'react';
import { Button, Popconfirm, Tooltip } from '@duxton-web/ui';

import {
  ExperimentAssignmentStrategy,
  isCompatibleExperiment,
} from '../../constants';
import { Experiment } from '../../domain';
import { AccessControlWrapper } from '@/common/components';
import { getDomainFamily } from '@/common/domains';
import { AdaptiveExperiment } from '@/lib/PlannerDTOs';
import { AccessTargetInput, UserAction } from '@/utils/accessControl';
import { useAppNavigate } from '@/utils/navigation';

const Clone = ({
  variableTechFamilies,
  experiment,
  adaptiveExperiment,
  ghost,
  icon,
  experimentStrategy,
  accessTargets,
}: {
  variableTechFamilies: string[];
  experiment: Experiment;
  adaptiveExperiment: AdaptiveExperiment;
  ghost?: boolean;
  icon?: ReactNode;
  experimentStrategy: string;
  accessTargets?: AccessTargetInput[];
}) => {
  const { navigateTo } = useAppNavigate();

  const mainExperiment = experiment || adaptiveExperiment;

  if (
    experimentStrategy === ExperimentAssignmentStrategy.GEO_TIME_SLICE_SHUFFLE
  ) {
    return (
      <Tooltip title="Geo Time Slice Shuffle is no longer a valid assignment strategy">
        <Button type="secondary" size="small" disabled>
          Clone
        </Button>
      </Tooltip>
    );
  }

  return (
    <AccessControlWrapper
      action={UserAction.CLONE_CURRENT_EXPERIMENT}
      techFamilies={variableTechFamilies}
      accessTargets={accessTargets}
    >
      {(hasAccess) => {
        if (hasAccess && !isCompatibleExperiment(mainExperiment)) {
          return (
            <Popconfirm
              placement="bottomRight"
              title={
                'This experiment is not fully compatible with the new creation flow. Do you want to clone this experiment?'
              }
              onConfirm={() => {
                navigateTo(
                  `/${getDomainFamily()}/experiments/${mainExperiment?.name}/clone`,
                );
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button type="secondary" size="small">
                Clone
              </Button>
            </Popconfirm>
          );
        }

        return (
          <Button
            type="secondary"
            size="small"
            ghost={ghost}
            icon={icon}
            onClick={() => {
              navigateTo(
                `/${getDomainFamily()}/experiments/${mainExperiment?.name}/clone`,
              );
            }}
            disabled={!hasAccess}
          >
            Clone
          </Button>
        );
      }}
    </AccessControlWrapper>
  );
};

export default Clone;
